

export default {
  props: ['date'],
}

